import { useSession } from '../SessionContext';

type Props = {
  children: React.ReactNode;
  roles: string[];
};

const RequireRole = ({ children, roles }: Props) => {
  const { user, loadingUser } = useSession();

  if (loadingUser) {
    return null;
  }

  if (!user?.role || !roles.includes(user.role)) {
    return null;
  }

  return <>{children}</>;
};

export default RequireRole;
